module.exports = __webpack_public_path__ + "img/mr.ee53e337.svg";